import * as React from "react";

import { Button, Modal } from "semantic-ui-react";

export interface DisclaimerModalProps {
    openModal: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

const DisclaimerModal: React.FC<DisclaimerModalProps> = (props: DisclaimerModalProps) => {

    const onCancel = React.useCallback(() => {
        props.onCancel();
    }, []);

    const onConfirm = React.useCallback(() => {
        props.onConfirm();
    }, []);

    return (
        <Modal size="tiny" open={props.openModal}>
            <Modal.Header content="Messaging Disclaimer" />
            <Modal.Content>
                <p>Please note that any messages or information exchanged in this part of the system will be viewable
                    by any other Managers or members of the HR team who have access to this case or may have access to
                    this case in the future. The employee will not be able to see these messages in our system but they
                    would be disclosed to the employee if we received a specific Subject Access Request.</p>
            </Modal.Content>
            <Modal.Actions>
                <Button content="Confirm" onClick={onConfirm} />
                <Button content="Cancel" onClick={onCancel} />
            </Modal.Actions>
        </Modal>
    );
};

export {
    DisclaimerModal
};
